import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
/*Import pages*/
import Home from './pages/index';
import SignIn from './pages/SignIn';
import ForgotPassword from './pages/ForgotPassword';
import Signup from './pages/Signup';
import UpdateProfile from './pages/UpdateProfile';
import UpdateEmailPassword from './pages/UpdateEmailPassword';
import GratitudeDiary from './pages/GratitudeDiary';
import UploadBlog from './pages/UploadBlog';
/*Importing AuthProvider*/
import AuthProvider from './context/AuthContext';
/*Importing Components*/
import PrivateRoute from './components/PrivateRoute';
import Blogs from './components/Blogs';
function App() {
  return (
    <Router>
      <AuthProvider>
        <Switch>
          <Route path="/" component={Home} exact />
          <PrivateRoute exact path="/update-profile" component={UpdateProfile} />
          <PrivateRoute path="/update-email-password" component={UpdateEmailPassword} />
          <PrivateRoute path="/gratitude-diary" component={GratitudeDiary} />
          <Route path="/signin" component={SignIn} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/signup" component={Signup} />
          <Route path="/blogs" component={Blogs} />
          <PrivateRoute path="/upload-blog" component={UploadBlog} />
        </Switch>
      </AuthProvider>
    </Router>
  );
}
export default App;
